export default {
    lockStatus: true
};
